module.exports = __webpack_public_path__ + "img/07.735d8a56.png";